export default `
    <div id="#= data.id || "" #" class="#: data.classes || "" # #=data.bsc||""#" screenentitytype="#= data.ScreenEntityType #" style="#=data.style || ""#"></div>
`;
